import { Button, Col, Form, Input, message, Row, Spin, Table } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import API from "../../../services/api-request";
import { capitalizeLetter } from "../../../utils/capitalizeLetter";

const DetailInvoiceClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editForm] = Form.useForm();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getDataDetail = (id) => {
    setLoading(true);
    API.Get(`invoice/detail/${id}`)
      .then((result) => {
        setLoading(false);

        const transformedItem = {
          ...result?.data,
          status: result?.data?.status === "paid" ? "Lunas" : "Belum Bayar",
          paid_at: result?.data?.paid_at ? dayjs(result?.data?.paid_at) : "",
          amount: result?.data?.amount?.toLocaleString("id-ID"),
          grand_total: result?.data?.grand_total?.toLocaleString("id-ID"),
          total_material_handling_fee_cost: result?.data
            ?.total_material_handling_fee_cost
            ? result?.data?.total_material_handling_fee_cost.toLocaleString(
                "id-ID"
              )
            : 0,
        };

        editForm.setFieldsValue(transformedItem);

        setData(transformedItem);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        message.info("Failed Fetch Request Invoice Detail");
      });
  };

  useEffect(() => {
    console.log(id);
    if (id) {
      getDataDetail(id);
    }
  }, [id]);

  const onFinish = async (values) => {};

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const colunsItem = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Jenis Produk",
      dataIndex: "product",
      key: "product",
      sorter: (a, b) => a.product?.name - b.product?.name,
      render: (product) => {
        if (product?.name === null || product?.name === "") {
          return "-";
        } else {
          return product?.name;
        }
      },
    },
    {
      title: "Berat Keluar",
      dataIndex: "weight",
      key: "weight",
      sorter: (a, b) => a.weight - b.weight,
      render: (weight) => {
        if (weight === null || weight === "") {
          return "-";
        } else {
          return `${weight.toLocaleString("id-ID", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })} Kg`;
        }
      },
    },
    {
      title: "Jumlah Pack",
      dataIndex: "qty",
      key: "qty",
      sorter: (a, b) => a.qty - b.qty,
      render: (qty) => {
        if (qty === null || qty === "") {
          return "-";
        } else {
          return qty;
        }
      },
    },
    {
      title: "Spesifikasi",
      dataIndex: "specification",
      key: "specification",
      sorter: (a, b) => a.specification - b.specification,
      render: (specification) => {
        if (specification === null || specification === "") {
          return "-";
        } else {
          return specification;
        }
      },
    },
    {
      title: "Total",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount,
      render: (amount) => {
        if (amount === null || amount === "") {
          return "-";
        } else {
          return `Rp. ${amount.toLocaleString("id-ID")}`;
        }
      },
    },
    {
      title: "Tanggal Inbound",
      dataIndex: "inbound_date",
      key: "inbound_date",
      sorter: (a, b) => a.inbound_date - b.inbound_date,
      render: (inbound_date) => {
        if (inbound_date === null || inbound_date === "") {
          return "-";
        } else {
          return dayjs(inbound_date).format("YYYY-MM-DD");
        }
      },
    },
    {
      title: "Tanggal Outbound",
      dataIndex: "outbound_date",
      key: "outbound_date",
      sorter: (a, b) => a.outbound_date - b.outbound_date,
      render: (outbound_date) => {
        if (outbound_date === null || outbound_date === "") {
          return "-";
        } else {
          return dayjs(outbound_date).format("YYYY-MM-DD");
        }
      },
    },
  ];

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Row gutter={[8, 8]}>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Nomor"
                name="invoice_number"
                rules={[
                  {
                    required: true,
                    message: "Please input your Nomor!",
                  },
                ]}
              >
                <Input placeholder="Nomor" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Tanggal Bayar"
                name="paid_at"
                rules={[
                  {
                    required: true,
                    message: "Please input your Tanggal Bayar!",
                  },
                ]}
              >
                <Input placeholder="Pilih Tanggal Bayar" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Total"
                name="grand_total"
                rules={[
                  {
                    required: true,
                    message: "Please input your Total!",
                  },
                ]}
              >
                <Input prefix="Rp" placeholder="Total" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please input your Status!",
                  },
                ]}
              >
                <Input placeholder="Status" readOnly />
              </Form.Item>
            </Col>
            <Col lg={12} md={12} sm={12} xs={24}>
              <Form.Item
                label="Total Material Handling Fee"
                name="total_material_handling_fee_cost"
              >
                <Input
                  prefix="Rp"
                  placeholder="Total Material Handling Fee"
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <div style={{ fontWeight: 600, marginBottom: 10 }}>
                Item Invoice
              </div>
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Table
                dataSource={data.invoice_items}
                columns={colunsItem}
                pagination={false}
              />
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Button
                style={{
                  width: "100%",
                  backgroundColor: "orange",
                  borderColor: "orange",
                  color: "white",
                }}
                type="primary"
                onClick={() => handleBack()}
              >
                Kembali
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};

const buttonStyle = {
  width: "100%",
};

export default DetailInvoiceClient;
